export default __webpack_public_path__ + "static/media/nutritionist.79064212.svg";